import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderRangeGroup from '../../../../../common/components/render-input/range-group';
import RenderInput from '../../../../../common/components/render-input';
import { trackingEvent } from '../../../../../helpers/tracking';

const tracking = {
    eventAction: 'Prosperity Planner - Step 3',
    eventLabel: 'Must Do and Love To'
};

export const formName = Routes.STEPTHREE;

const priorityOptions = {
    'setAsideMonthly': 'Set $ aside monthly',
    'reduceDebtStress': 'Reduce debt stress',
    'homeOfMyOwn': 'Home of my own',
    'aBetterHomeOfMyOwn': 'A better home of my own',
    'reliableTransportation': 'Reliable transportation',
    'flexibilityInMyBudget': 'Flexibility in my budget',
    'doMyOwnBusinessThing': 'Do my own business thing',
    'travelTheWorld': 'Travel the world',
    'investLikeAGuru': 'Invest like a guru',
    'investInMyCommunity': 'Invest in my community',
    'babies': 'Babies',
    'educateMyKids': 'Educate my kids',
    'educateMyself': 'Educate myself',
    'gourmetKitchensEnSuites': 'Gourmet kitchens & en-suites',
    'freedomFifySomething': 'Freedom fifty-something',
    'freedomSixtySomething': 'Freedom sixty-something',
    'personalWellness': 'Personal wellness',
    'justHaveDinnerOutWhenever': 'Just have dinner out whenever'
};

let priorityFields = {};
Object.keys(priorityOptions).forEach(option =>
    priorityFields[option] = {label: priorityOptions[option]}
);

const rangeValues = ['N/A', 'Must Do', 'Love To'];

const priorityValues = {
    'not-applicable': rangeValues[0],
    'must-do': rangeValues[1],
    'love-to': rangeValues[2]
};

export const formDetails = {
    key: 'mustDoLoveTo',
    title: 'Must Do Love To',
    formName,
    totalKey: 'mustDoLoveToTotal',
    fields: {
        ...priorityFields,
        'loveToTotal': 0,
        'mustDoTotal': 0,
    },
    rangeValues
};

const minValue = "0";

const calculateTotal = (values, type) =>
    Object.values(values).reduce((total, current) => {
        current = parseInt(current, 10);
        total = parseInt(total, 10);
        return current === type ? total + 1 : total;
    }, 0);

// eslint-disable-next-line
const onChange = (formValues, fields, props) => {
    const {
        changeFieldValue
    } = props;
    const {
        loveToTotal,
        mustDoTotal,
        ...values
    } = formValues;
    changeFieldValue('mustDoTotal', calculateTotal(values, 1));
    changeFieldValue('loveToTotal', calculateTotal(values, 2));
};

class StepThreeForm extends Component {
    render() {
        const {
            formValues: {
                loveToTotal: loveToTotal = 0,
                mustDoTotal: mustDoTotal = 0,
                ...values
            } = {}
        } = this.props;
        return (
            <form
                className={styles.form}
            >
                <RenderRangeGroup
                    options={priorityOptions}
                    values={priorityValues}
                    defaultValues={values}
                />
                <div className={styles.totalContainer}>
                    <Field
                        type='text'
                        name="mustDoTotal"
                        label="Must Do Total"
                        readOnlyValue={mustDoTotal}
                        component={RenderInput}
                    />
                    <Field
                        type='text'
                        name="loveToTotal"
                        label="Love To Total"
                        readOnlyValue={loveToTotal}
                        component={RenderInput}
                    />
                </div>
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepThreeForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    onSubmit,
    onChange,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPFOUR}`,
    tracking: () => trackingEvent(tracking)
})(StepThreeForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepThreeForm));
